import { type FC, type ReactNode } from "react";

import { ArrowRight } from "lucide-react";

import { Button } from "@/shared/components/ui/button";
import { Tag } from "@/shared/components/ui/tag";

export interface HeroCardProps {
  tagLabel?: string;
  bgColor: string;
  illustration: string;
  title: string;
  description: string;
  children?: ReactNode;
  ctaLabel: string;
  ctaSubtext?: string;
  onCtaClick: () => void;
}

export const HeroCard: FC<HeroCardProps> = ({
  tagLabel = "Your next step",
  bgColor,
  illustration,
  title,
  description,
  children,
  ctaLabel,
  ctaSubtext,
  onCtaClick,
}) => {
  return (
    <section className="flex flex-col sm:flex-row items-stretch border border-primary rounded-lg overflow-hidden bg-white">
      <div
        className={`${bgColor} flex items-center justify-center p-12 sm:w-[250px] sm:shrink-0 sm:py-16`}
      >
        <img src={illustration} alt="" className="size-[150px]" aria-hidden="true" />
      </div>
      <div className="flex flex-col justify-center gap-6 p-6 flex-1 min-w-0">
        <div className="flex flex-col gap-2">
          <div className="flex flex-col gap-3">
            <div className="flex">
              <Tag color="white" size="sm">
                {tagLabel}
              </Tag>
            </div>
            <h4>{title}</h4>
            <p className="text-secondary text-sm tracking-[-0.02em]">{description}</p>
          </div>
          {children}
        </div>
        <div className="flex items-center gap-4">
          <Button variant="brand" rounded className="gap-2.5 px-6" onClick={onCtaClick}>
            {ctaLabel}
            <ArrowRight className="size-4" />
          </Button>
          {ctaSubtext && (
            <span className="text-sm text-secondary tracking-[-0.02em]">{ctaSubtext}</span>
          )}
        </div>
      </div>
    </section>
  );
};
